import axios from "axios";

export const getDropdownPelangganJenis = async () => {
  return await axios.get(`${window._HOST}admin/pelangganJenis/dropdown`, {
    withCredentials: true,
  });
};

export const getAllDataTablePelangganJenis = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/pelangganJenis/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/pelangganJenis/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const insertNewPelangganJenis = async (formData) => {
  return await axios.post(`${window._HOST}admin/pelangganJenis`, formData, {
    withCredentials: true,
  });
};

export const updatePelangganJenis = async (formData, id_pelanggan_jenis) => {
  return await axios.put(
    `${window._HOST}admin/pelangganJenis/${id_pelanggan_jenis}`,
    formData,
    { withCredentials: true }
  );
};

export const deletePelangganJenis = async (id_pelanggan_jenis) => {
  return await axios.delete(
    `${window._HOST}admin/pelangganJenis/${id_pelanggan_jenis}`,
    { withCredentials: true }
  );
};
